// @flow
import {
  UPDATE_APP,
  TRIGGER_UPDATE_APP,
  HIDE_INSTALL_BANNER,
  SHOW_INSTALL_PROMPT,
  APP_INSTALLED,
  HIDE_INSTALL_PROMPT,
  TRIGGER_INSTALL
} from "./types";
import type { Action } from "./types";

export const triggerUpdateApp = (): Action => ({
  type: TRIGGER_UPDATE_APP
});

export const updateApp = (): Action => ({
  type: UPDATE_APP
});

export const hideInstallBanner = (): Action => ({
  type: HIDE_INSTALL_BANNER
});

export const showIntallPrompt = (event: Event): Action => ({
  type: SHOW_INSTALL_PROMPT,
  payload: event
});

export const appInstalled = (): Action => ({
  type: APP_INSTALLED,
});

export const hideInstallPrompt = (): Action => ({
  type: HIDE_INSTALL_PROMPT,
});

export const triggerAppInstall = (): Action => ({
  type: TRIGGER_INSTALL,
});